"use client";

import { useRouter } from "@/i18n/routing";
import { useSearchParams } from "next/navigation";

export default function useAnimatedRouter() {
    const router = useRouter();
    const searchParams = useSearchParams();

    const refresh = () => {
        router.refresh();
    }

    const getTenant = (): string => {
        const splitted: string[] = window.location.pathname?.split('/') ?? [];
        return splitted.length >= 3 ? `${splitted[2]}` : '';
    }

     const getVersion = (): string => {
        const splitted: string[] = window.location.pathname?.split('/') ?? [];
        return splitted.length >= 4 ? `${splitted[3]}` : '';
    }

    const replace = (url: string) => {
        router.replace(`${getTenant()}/${getVersion()}${url}`);
    }

    // Navigate to the new route
    const animatedRoute = async (url: string, stripQuery = false) => {

        let urlFull = `/${getTenant()}/${getVersion()}`;
        urlFull += url;

        if (!stripQuery && searchParams.size > 0) {

            if (url.indexOf('?') == -1) {
                urlFull += '?'
            }
            searchParams.forEach((value, key) => {
                if (!urlFull.endsWith('?')) {
                    urlFull += '&';
                }
                urlFull += key + '=' + value;
            })
        }

        return router.push(urlFull, {});
    };

    return { replace, refresh, animatedRoute, router, searchParams };
}